import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RuntimeConfigService implements OnDestroy {
  prequalConfig: any;

  private destroyed$ = new Subject<void>();

  constructor() {
    this.prequalConfig = (window as any).prequalConfig || {};
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
